'use strict';

import angular from 'angular';
import { Enum } from '../../enum/index';

export class AddNewInsuranceOfferPopupController {
  billData = {};
  forms = {
    insuranceOfferForm: null
  };
  Enum = Enum;

  /*@ngInject*/
  constructor(mdPanelRef, $mdPanel, insuranceOffer, pageSettings, helper, refresh) {
    let vm = this;
    vm._mdPanelRef = mdPanelRef;
    vm.$mdPanel = $mdPanel;
    vm.insuranceOffer = {
      insuranceOfferPrice: [],
      insuranceOfferPeriod: []
    };
    vm.theme = pageSettings.theme;


    vm.save = () => {
      vm.forms.insuranceOfferForm.$setSubmitted();

      if (vm.forms.insuranceOfferForm.$valid) {
        insuranceOffer.save(vm.insuranceOffer).then(data => {
          refresh();
          helper.showOperationSuccessToast();
          vm.hide();
        }).catch(() => {
          helper.showOperationFailedToast();
        });
      }
    };
    vm.hide = function () {
      let panelRef = vm._mdPanelRef;
      panelRef.destroy();
    };

    vm.addEmptyPriceItem = () => {
      if (!vm.insuranceOffer.insuranceOfferPrice || (vm.insuranceOffer.insuranceOfferPrice && !_.isArray(vm.insuranceOffer.insuranceOfferPrice))) {
        vm.insuranceOffer.insuranceOfferPrice = [];
      }

      let lastIndex = vm.insuranceOffer.insuranceOfferPrice.length - 1;

      if ((lastIndex >= 0 && vm.insuranceOffer.insuranceOfferPrice[lastIndex].name && vm.insuranceOffer.insuranceOfferPrice[lastIndex].price) || lastIndex < 0) {
        vm.insuranceOffer.insuranceOfferPrice.push({name: '', price: null });
      }
    };
    vm.deletePriceItem = (index) => {
      vm.insuranceOffer.insuranceOfferPrice.splice(index, 1);
    };

    vm.addEmptyPeriodItem = () => {
      if (!vm.insuranceOffer.insuranceOfferPeriod || (vm.insuranceOffer.insuranceOfferPeriod && !_.isArray(vm.insuranceOffer.insuranceOfferPeriod))) {
        vm.insuranceOffer.insuranceOfferPeriod = [];
      }

      let lastIndex = vm.insuranceOffer.insuranceOfferPeriod.length - 1;

      if ((lastIndex >= 0 && vm.insuranceOffer.insuranceOfferPeriod[lastIndex].dateTo && vm.insuranceOffer.insuranceOfferPeriod[lastIndex].dateFrom && vm.insuranceOffer.insuranceOfferPeriod[lastIndex].name) || lastIndex < 0) {
        vm.insuranceOffer.insuranceOfferPeriod.push({dateFrom: null, dateTo: null, name: null });
      }
    };
    vm.deletePeriodItem = index => {
      console.log(vm.insuranceOffer.insuranceOfferPeriod);
      vm.insuranceOffer.insuranceOfferPeriod = vm.insuranceOffer.insuranceOfferPeriod.splice(index, 1);
      vm.addEmptyPeriodItem();
    };

    vm.addEmptyPeriodItem();
    vm.addEmptyPriceItem();
  }
  cancel() {
    this._mdPanelRef.hide();
  }
}

export default angular.module('ngOskCrmApp.popup.addNewInsuranceOfferPopupController', [])
  .controller('addNewInsuranceOfferPopupController', AddNewInsuranceOfferPopupController)
  .name;



// WEBPACK FOOTER //
// ./client/app/shared/popup/add-new-insurance-offer-popup/add-new-insurance-offer-popup.controller.js